/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Column } from 'wrappers/FlexTable'
import Popover from 'components/generic/Popover'
import clsx from 'clsx'
import SubwayRow from 'components/listings/cards/components/SubwayRow'
import s from './Subway.module.css'
import subwayLinesIcon from './assets/subwayLines.png'
import subwayStopsIcon from './assets/subwayStops.png'
import { SubwayLines } from './components/SubwayLines'

import { SubwayStops } from './components/SubwayStops'

export const Subway = (props) => {
  const { loading, value: currentValue, onChange, options, customClassName } = props

  const targetRef = useRef(null)
  const [value, setValue] = useState('')

  const SUBWAY_OPTIONS = useMemo(
    () => [
      {
        label:
          currentValue?.subwayLines?.length > 0 ? `Subway Line (${currentValue?.subwayLines?.length})` : 'Subway Line',

        value: 'subwayLines',
        image: subwayLinesIcon,
        content: (
          <SubwayLines
            onChange={(value) => {
              onChange?.onLineChange?.(value)
              targetRef.current?.click()
            }}
            initialValues={currentValue?.subwayLines || []}
            loading={loading}
            options={options.subwayLines?.map((item) => ({
              label: item.line,
              name: item.line,
              value: item.line,
            }))}
          />
        ),
      },
      {
        label:
          currentValue?.subwayStops?.length > 0 ? `Subway Stop (${currentValue?.subwayStops?.length})` : 'Subway Stop',
        value: 'subwayStops',
        image: subwayStopsIcon,
        content: (
          <SubwayStops
            onChange={(value) => {
              onChange?.onStopChange?.(value)
              targetRef.current?.click()
            }}
            initialValues={currentValue?.subwayStops || []}
            loading={loading}
            options={options.subwayStops?.map((item) => ({
              label: (
                <>
                  {item.name}
                  <SubwayRow subwayLines={item.lines} />
                </>
              ),
              name: item.name,
              value: item.id,
            }))}
          />
        ),
      },
    ],
    [options, currentValue]
  )

  const className =
    (currentValue.subwayStops?.length > 0 || currentValue.subwayLines?.length > 0) && !loading
      ? 'btn-transparent-yellow'
      : 'btn-transparent-gray'
  const buttonClassName = clsx(`button btn-rounded ${className} btn-search-bar-size`, customClassName)
  const content = value ? SUBWAY_OPTIONS.find((option) => option.value === value)?.content : null

  const currentValuesNum = useMemo(
    () => (currentValue?.subwayStops?.length || 0) + (currentValue?.subwayLines?.length || 0),
    [currentValue]
  )

  return (
    <Column className="searchbar-col">
      <Popover type="click" targetRef={targetRef} onClose={() => setValue('')}>
        <div className="subwayPopup">
          <Column className={s.container}>
            {content || (
              <div className={s.options}>
                {SUBWAY_OPTIONS.map((option) => (
                  <div
                    role="button"
                    tabIndex={0}
                    key={option.value}
                    className={clsx(s.option, value === option.value && s.selectedOption)}
                    onClick={() => setValue(option.value)}
                  >
                    <div className={s.optionImageWrapper}>
                      <img src={option.image} alt={option.label} className={s.optionImage} />
                    </div>
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </Column>
        </div>
      </Popover>
      <input
        ref={targetRef}
        name="subway"
        type="button"
        className={buttonClassName}
        value={currentValuesNum > 0 ? `Subway (${currentValuesNum})` : 'Subway'}
      />
    </Column>
  )
}

Subway.defaultProps = {
  value: {
    subwayLines: [],
    subwayStops: []
  },
  loading: false,
}

Subway.propTypes = {
  value: PropTypes.shape({
    subwayLines: PropTypes.arrayOf(PropTypes.string),
    subwayStops: PropTypes.arrayOf(PropTypes.string)
  }),
  loading: PropTypes.bool,
  onChange: PropTypes.shape({
    onLineChange: PropTypes.func,
    onStopChange: PropTypes.func
  }),
  options: PropTypes.shape({
    subwayLines: PropTypes.arrayOf(PropTypes.shape({})),
    subwayStops: PropTypes.arrayOf(PropTypes.shape({}))
  })
}
